function iOSDetector() {
  return navigator.userAgent.includes("Mac");
}

if (iOSDetector()) {
  const title_home_i = document.querySelector('._home section._i ._info');
  title_home_i.classList.add('ios');

  const title_home_vii = document.querySelector('._home section._vii ._inside ._titles');
  title_home_vii.classList.add('ios');

  const cards_home_iv = document.querySelector('._home section._iv aside._two ._body ._card_pdps');
  cards_home_iv.classList.add('ios');
}